// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yarl__container{background-color:rgba(0,0,0,.8)}", "",{"version":3,"sources":["webpack://./../../../../common/common-components/src/lightbox/YetAnotherLightbox.scss"],"names":[],"mappings":"AAAA,iBACE,+BAAA","sourcesContent":[".yarl__container {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
